module.exports = __webpack_public_path__ + "static/media/110gb.c94cba47.png";


//////////////////
// WEBPACK FOOTER
// ./src/media/img-on-satelital/110gb.png
// module id = 139
// module chunks = 0